// import Util from '@/assets/libs/util'
import ptbr from '@/assets/lang/pt-br'
import en from '@/assets/lang/en'
import es from '@/assets/lang/es'

const currentLanguage = 'pt-br'

const getString = key => {
  const languageOptions = {
    en: en.getString,
    es: es.getString,
    'pt-br': ptbr.getString
  }

  const curLang = languageOptions[currentLanguage]
  return curLang && typeof curLang === 'function' && curLang(key) ? curLang(key) : key
}

const getIndexLanguages = function (product, index) {
  const defaultLanguage = 'pt-br'
  const keys = {
    // primeiro nivel de produtos
    groupName: {
      en: 'groupNameEnglish',
      es: 'groupNameEspanish',
      'pt-br': 'groupName'
    },
    productName: {
      en: 'productNameEnglish',
      es: 'productNameEspanish',
      'pt-br': 'productName'
    },
    obsName: {
      en: 'obsNameEnglish',
      es: 'obsNameEspanish',
      'pt-br': 'obsName'
    },
    productGroupName: {
      en: 'productGroupNameEnglish',
      es: 'productGroupNameEspanish',
      'pt-br': 'productGroupName'
    },
    subItemName: {
      en: 'subItemNameEnglish',
      es: 'subItemNameEspanish',
      'pt-br': 'subItemName'
    },
    subItemObsGroupName: {
      en: 'subItemObsGroupNameEnglish',
      es: 'subItemObsGroupNameEspanish',
      'pt-br': 'subItemObsGroupName'
    },
    subItemObsName: {
      en: 'subItemObsNameEnglish',
      es: 'subItemObsNameEspanish',
      'pt-br': 'subItemObsName'
    },
    subProductGroupName: {
      en: 'subProductGroupNameEnglish',
      es: 'subProductGroupNameEspanish',
      'pt-br': 'subProductGroupName'
    },
    subGroupName: {
      en: 'subGroupNameEnglish',
      es: 'subGroupNameEspanish',
      'pt-br': 'subGroupName'
    },
    productDescription: {
      en: 'productDescriptionEnglish',
      es: 'productDescriptionEspanish',
      'pt-br': 'productDescription'
    },
    obsGroupName: {
      en: 'obsGroupNameEnglish',
      es: 'obsGroupNameEspanish',
      'pt-br': 'obsGroupName'
    },
    subItemDescription: {
      en: 'subItemDescriptionEnglish',
      es: 'subItemDescriptionEspanish',
      'pt-br': 'subItemDescription'
    }
  }
  return (product[keys[index][currentLanguage]]) || (product[keys[index][defaultLanguage]])
}
export default {
  getString: getString,
  getIndexLanguages
}
